// extracted by mini-css-extract-plugin
export default {"disclaimers":"nYPlbpkL6l"};